import React from 'react';
import { usePagoUnico } from '~/store/States/pospago';
import '~/sass/modules/_pagoUnico.scss';

export default function PagoUnicoInfo() {
  const pagoUnico = usePagoUnico();
  if (!pagoUnico) return null;
  return (
    <div className="pago-unico">
      <div className="info">
        <div className="icon-container">
          <span className="icon">i</span>
        </div>
        <span className="text" dangerouslySetInnerHTML={{ __html: pagoUnico.textos.aviso }}></span>
      </div>
    </div>
  );
}
